import $ from 'jquery';

// Webform styles
var $input = $('.form-item input.form-text, .form-item input.form-email');

$($input).click(function() {
    $(this).parent().find('label').addClass('active');
});

$($input).on('focus', function() {
    $(this).parent().find('label').addClass('active');
});

$($input).each(function() {
    if ($(this).val()) {
        $(this).parent().find('label').addClass('active');
    }
});

$($input).on('blur', function() {
    if (!$(this).val()) {
        $(this).parent().find('label').removeClass('active');
    }
});

// Webform Country / Phone code
(function ($) {
    $("#edit-pays").on('change', function() {
        $.ajax({
            url: "/rest-get-countrycode-by-id/"+this.value, // vue Drupal de type REST
        }).done(function(data){
            if ($("#edit-telephone-all").length) {
                $("#edit-telephone-all").intlTelInput('setCountry', data.length > 0 ? data[0].field_indicatif_pays.toLowerCase() : 'gb' );
            }
        });
    });
})(jQuery);


// Webform Contact
(function ($) {
    if ($('.page-contact').length) {
        var $description = $('.page-contact .js-form-type-webform-email-multiple .description').height();
        var $form_item = $('.page-contact .js-form-type-webform-email-multiple');
        $form_item.css('margin-bottom', $description);
    }

    //#block-gorgytime-content > article > div > div je souhaite encadré les 2 première div enfant par une div .columns
    var $columns = $('#block-gorgytime-content > article > div > div > div');
    $columns.slice(0, 2).wrapAll('<div class="columns"></div>');

})(jQuery);

// MAP
(function ($, Drupal) {

    Drupal.behaviors.customLeafletInteraction = {
      attach: function (context, settings) {

        $(context).on('leafletMapInit', function (e, settings, map, mapid, markers) {
            var customIcon = L.icon({
                iconUrl: '/themes/custom/gorgytime/src/icons/marker_map.png',
                iconSize: [41, 41],
                iconAnchor: [41, 41],
                popupAnchor: [1, -34], 
                shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-shadow.png',
                shadowSize: [41, 41]
            });

            // Appliquer l'icône personnalisée à vos marqueurs
            for (var i in markers) {
                markers[i].setIcon(customIcon);
                markers[i]._icon.classList.add("gorgy-marker");
            }
        })
      }
    }

})(jQuery, Drupal);

// if i click to button submit #edit-wizard-next i add datalayer
(function ($) {
    $('#edit-wizard-next').on('click', function() {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({'event' : 'form_progress',
            'action':'ok',
        });

        // Si tous les champs obligatoire sont remplis
        if ($('.form-item .required').length) {
            dataLayer.push({'event' : 'form_complete',
                'action':'sucess',
            });
        }
    });
})(jQuery);

